import React from 'react'

import AddPackageForm from '../../modules/Package/components/AddPackageForm'
export default function AddPackagePage() {
  return (
    <AddPackageForm/>  )
}
